import { apiGet, apiPost } from "./api-client";

// 资金流水记录：POST /api/user/records { page, limit, type }
// type: 1=兑换 2=提现 3=挖矿 4=活动
function getRecords(type, page = 1, limit = 10) {
  return apiPost("/api/user/records", { page, limit, type });
}

export function getOrderExchange(page = 1, limit = 10) {
  return getRecords(1, page, limit);
}

export function getOrderWithdraw() {
  // 提现记录单独接口：POST /api/user/withdrawList（无参数）
  return apiPost("/api/user/withdrawList", {});
}

export function getOrderProfit(page = 1, limit = 10) {
  // 收益 = 挖矿流水
  return getRecords(3, page, limit);
}

export function getActivityRecords(page = 1, limit = 10) {
  return getRecords(4, page, limit);
}

export function claimActivityBonus() {
  // TODO: 旧接口，待后端提供新的领取活动奖励接口
  return apiGet("/v1/api/claimActivityBonus");
}
